
export default{
    scale_axis(data,minval,minstep) {
       
        let d=[];
        data.forEach(o=>{
            if(o){
                d.push(parseFloat(o))
            }
        });  //clone 
        d.sort((a,b)=>{return a-b;});
    
        let len=d.length, up=d[len-1], lo=d[0];
        if(minval!==undefined) lo=minval;
    
        let steps=[4,5,6],result;
        steps.forEach(o=>{ 
            let r=scale_axis_lo_up(lo,up,o,minstep);
            if(!result || r.diff<result.diff) result=r;
            //console.log(r)
        })
    
        //console.log(result)
        return result;
    
        /**
         * 纵坐标规范处理，
         * @param {Number} lo  最小值
         * @param {Number} up  最大值
         * @param {Number} steps 大概格数
         * @param {Number} minstep 最小步长，如果不指定则以计算为准
         * @returns {Object} { min:x,max:x,lo:x, up:x,step:x,steps:x.diff:x};
         */
        function scale_axis_lo_up(lo,up,steps,minstep) {
            steps=3;
            if(up==lo) {  
                if(lo<2) { lo-=0.5;  up+=0.5;  }
                else if(lo<5) { lo-=2;  up+=2;  }
                else if(lo<10) { lo-=5;  up+=5;  }
                else if(lo<100) { lo-=10;  up+=10;  }
                else {lo-=20;  up+=20;  }
                
                if(lo<0) lo=0; 
            }
            let r=up-lo,tick_count=steps,unrounded_tick_size=~~(r/(tick_count-1));
            if(unrounded_tick_size===0) unrounded_tick_size=1;
        
            let x=Math.ceil(Math.log10(unrounded_tick_size)-1),pow10x=Math.pow(10,x),
                rounded_tick_range=Math.ceil(unrounded_tick_size / pow10x) * pow10x;
        
            let new_lower = rounded_tick_range * Math.round((lo-1)/rounded_tick_range),
                new_upper = rounded_tick_range * Math.round(up/rounded_tick_range);
            let st=step_size(new_upper-new_lower,steps);
            if(minstep && st<minstep) st=minstep;//如果指定了最小步长,...
            
            new_lower=~~(new_lower/st) * st;  //最小在steps整数倍
            new_upper=new_lower+steps*st;     //最大在steps整数倍
            
            if(new_lower>lo) new_lower-=st;
        
            if(lo!==0 && new_lower>lo-st/2) new_lower-=st; //不能立地
            if(lo>=0 && new_lower<0) new_lower=0;          //但是,如果最小值》0,不能突破0
            
            //console.log(new_upper)
            while(new_upper<up+st/2) new_upper+=st; //不能顶天
            new_upper=parseFloat(new_upper.toFixed(3));
            return { min:lo,max:up, lo:new_lower,up:new_upper,step:st,steps:steps,diff:new_upper-up};
        }
        
        function step_size(r, target_steps) {
           let temp_step = r/target_steps;                  //calculate an initial guess at step size
           if(temp_step<0.1) temp_step=0.1;
           else if(temp_step<0.2) temp_step=0.2;
           else if(temp_step<0.5) temp_step=0.5;
           
           let mag = Math.floor(Math.log10(temp_step)),     //get the magnitude ofdata the step size
               mag_pow = Math.pow(10, mag),
               mag_msd = parseInt(temp_step/mag_pow + 0.5); //calculate most significant digit of the new step size
           
           if (mag_msd > 5.0) mag_msd = 10.0;               //promote the MSD to either 1, 2, or 5
           else if (mag_msd > 2.0) mag_msd = 5.0;
           else if (mag_msd > 1.0) mag_msd = 2.0;
        
           return mag_msd * mag_pow;
        }        
    },
    /**
         * 格式化流量
         * 保留3位有效数字
         */
        convertQ: function (num) {
            if(num){
                num=parseFloat(num).toPrecision(3);
                let n=num.split('e+');
                if(!n[1]) return n[0];
                return parseFloat(parseFloat(n[0])*100).toFixed(0)*Math.pow(10,parseInt(n[1])-2);
            }else if(num==0){
                return 0
            }else{
                return null
            }
        },

}





// WEBPACK FOOTER //
// ./src/assets/util/echartsPlug.js